module.exports = __webpack_public_path__ + "static/media/flight-right2left.c0128219.svg";